<template>
  <el-card header="设备概况">
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="number-box" style="background-color: #19be6b;" @click="showDevices">
          <span class="title">在线设备</span>
          <div class="number">在线{{record.online||0}}台/共{{record.total||0}}台</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="number-box" style="background-color: #409EFF;">
          <span class="title">本年节电率</span>
          <div class="number">{{record.savePercent||0}}%</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="number-box" style="background-color: #2db7f5;">
          <span class="title">本年节电费</span>
          <div class="number">{{record.saveMoney||0}}元</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="number-box" style="background-color: #F56C6C;">
          <span class="title">本年节电量</span>
          <div class="number">{{record.saveKwh}}度</div>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import SessionStore from "@/utils/SessionStore";

export default {
  name: "ConsoleTotals",
  extends: BaseVue,
  data() {
    return {
      record: {}
    }
  },
  created() {
    this.postForm("/device-status/compCurrentInfo").then((dr) => {
      this.record = dr.bean;
    });
  },
  methods: {
    showDevices() {
      let me = SessionStore.getUser();
      if(me.company.compType == '1') {
        this.$router.push("/deviceList")
      } else {
        this.$router.push("/myDeviceList")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.number-box{
  border: 1px solid #eaeaea;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  padding: 15px;
  cursor: pointer;
  .title{
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }
  .number{
    font-size:18px;
    font-weight: bold;
    line-height: 30px;
    color: #ffffff;
  }
}
</style>